import HttpService from '../../../modules/core/services/HttpService';
import Subscription from '../models/Subscription';
import Asset from '../models/Asset';
import { Subscriptions } from '../models/ApiResponse';

const httpService = HttpService.Instance;


class SubscriptionService {
  private static instance: SubscriptionService
  public success: string | undefined

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public async getAssetSubscriptions(): Promise<Asset[]> {
    const data: Subscriptions = await httpService.get(process.env.REACT_APP_API_URL + 'subscriptions', { enforceErrorPage: true }).then((response: Response) => response.json());
    const subscribedAssets: Asset[] = [];
    data.subscriptions.forEach((subscription: Subscription) => {
      let assetExists = false;
      subscribedAssets.forEach(asset => {
        if (asset.id === subscription.product.asset.id) {
          assetExists = true;
          asset.environments.push({
            id: subscription.environment.id,
            name: subscription.environment.name
          });
        }
      });
      if (!assetExists) {
        const asset = ({
          id: subscription.product.asset.id,
          owner: subscription.assetOwner,
          name: subscription.product.asset.name,
          environments: [{
            id: subscription.environment.id,
            name: subscription.environment.name
          }]
        } as Asset);
        subscribedAssets.push(asset);
      }
    });
    return subscribedAssets;
  }

  public async getSubscription(assetId: string, environment: string): Promise<Subscription> {
    const response = await httpService.get(process.env.REACT_APP_API_URL + 'subscriptions?assetId=' + assetId);
    const data: Subscriptions = await response.json();
    let result = new Subscription()

    data.subscriptions.forEach((subscription: Subscription) => {
      if (subscription.environment.name === environment && (!result.updatedOn || new Date(result.updatedOn) < new Date(subscription.updatedOn))) {
        result = subscription;
      }

    });
    if (!result.id) {
      window.location.assign(process.env.REACT_APP_APPLICATION_ROOT as string + 'error/' + encodeURI(' ') + '/' + encodeURI('Subsciption not found'))
    }
    return result
  }

  public async getApiKey(subscriptionId: string): Promise<string> {
    const response = await httpService.get(process.env.REACT_APP_API_URL + 'subscriptions/' + subscriptionId + '/api-key')
    const key = await response.json();
    return key.apiKey
  }


}

export default SubscriptionService



// WEBPACK FOOTER //
// ./src/modules/consumer/services/SubscriptionService.tsx